import React from 'react';

import { DataGrid, GridColDef } from '@mui/x-data-grid';

import DefinitionTitle from '~/components/Common/Elements/DefinitionTitle';
import MarkdownPreview from '~/components/Common/MarkdownPreview';

import { BONUS_INCLUSIONS_MAX_TO_NIGHTS } from '~/consts/ratePlans';

const columns: Array<GridColDef> = [
  { field: 'from_nights', headerName: 'Duration', sortable: false, display: 'flex' },
  {
    field: 'to_nights',
    headerName: 'To Nights',
    sortable: false,
    display: 'flex',
    valueGetter: (_value, row) =>
      row.to_nights === BONUS_INCLUSIONS_MAX_TO_NIGHTS ? row.from_nights + '+' : row.to_nights,
  },
  {
    field: 'content',
    headerName: 'Content',
    sortable: false,
    flex: 1,
    renderCell: (params) => <MarkdownPreview content={params.row.content} />,
    display: 'flex',
  },
];

export default function RatePlanBonusInclusions({ bonusInclusions }) {
  return (
    <div>
      <DefinitionTitle>Rate Plan Bonus Inclusions</DefinitionTitle>
      <div>
        <DataGrid
          columns={columns}
          rows={bonusInclusions}
          getRowHeight={() => 'auto'}
          disableRowSelectionOnClick
          autoHeight
          hideFooter
          disableColumnMenu
          disableColumnFilter
        />
      </div>
    </div>
  );
}
